import { SagaIterator } from "redux-saga";
import { FieldConfigFetchRequest, FieldConfigReduxType } from "./types";
import { fetchFieldConfigApi } from "./api";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

function* fetchFieldConfig({ payload }: FieldConfigFetchRequest): SagaIterator {
    try {
        const response = yield call(fetchFieldConfigApi, payload)
        yield put({
            type: FieldConfigReduxType.GET_FIELD_CONFIG_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: FieldConfigReduxType.GET_FIELD_CONFIG_ERROR,
            payload: { error: error }
        })
    }
}

export function* watchFetchFieldConfig(){
    yield takeEvery(FieldConfigReduxType.GET_FIELD_CONFIG,fetchFieldConfig)
}

function* fieldConfigSaga() {
    yield all([
        fork(watchFetchFieldConfig)
    ])
}

export default fieldConfigSaga;